export const userHasNoCustomersKey = 'userHasNoCustomers';
